// Generated by CoffeeScript 2.7.0
var NextReviewerAssignmentSetting;

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

export default NextReviewerAssignmentSetting = {
  components: {
    'filter-options': FilterOptions,
    'user-item': UserItem
  },
  props: {
    resource: {
      type: String,
      required: true
    },
    vertex: {
      type: Object
    }
  },
  data: function() {
    return {
      users: [],
      nextReviewers: []
    };
  },
  template: `<div v-if="users.length > 0" class="inline form-field next-reviewer-setting" :class="{required: required}">
  <div class="form-field-head">
    <div class="form-field-title">选择处理者</div>
  </div>
  <div class="form-field-input-container">
    <div class="form-field-input">
      <filter-options :groupedOptions='[{ options: users }]'
                      :multiple="true"
                      @valueChanged='reviewerSelectFunc'>
        <template slot='option-item-template' slot-scope='{ option }'>
          <div class="content vertical-middle">
            <user-item :user='option' size='small'/>
            <div class="user-identifier">{{ option.identifier }}</div>
          </div>
          <div class='tip primary-text'>
            <i :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
          </div>
        </template>
      </filter-options>
    </div>
  </div>
</div>`,
  created: function() {
    return this._fetchUsers();
  },
  watch: {
    resource: function() {
      this._fetchUsers();
      return this.clear();
    }
  },
  computed: {
    required: function() {
      return !!this.users.length;
    }
  },
  methods: {
    reviewerSelectFunc: function(vm) {
      return this.nextReviewers = vm.selectedOptions;
    },
    clear: function() {
      return this.nextReviewers = [];
    },
    getData: function() {
      return _.pluck(this.nextReviewers, 'id');
    },
    getValid: function() {
      var value;
      value = this.getData();
      if (this.required) {
        return !_.isEmpty(value);
      } else {
        return true;
      }
    },
    _fetchUsers: function() {
      this.users = [];
      return new Skylark.Libs.PaginatedResources(this.resource, {
        callback: (data) => {
          return this.users = this.users.concat(data);
        },
        completedCallback: () => {
          return _.each(this.users, (user, index) => {
            if (index === 0) {
              Vue.set(user, '_selected', true);
              return this.nextReviewers.push(user);
            } else {
              return Vue.set(user, '_selected', false);
            }
          });
        }
      });
    }
  }
};
